<template>
  <el-dialog :visible.sync="visible" title="选择班级" :close-on-click-modal="false"
             :close-on-press-escape="false">
    <el-form :model="dataForm" :rules="dataRule" ref="dataForm" @keyup.enter.native="dataFormSubmitHandle()"
             :label-width="$i18n.locale === 'en-US' ? '120px' : '80px'">
      <el-form-item label=" 班级" prop="classId">
        <!--<el-select v-model="dataForm.classId" placeholder="请选择" clearable style="width: 100%" :disabled="dataForm.id">
          <el-option v-for=" (classObj,index) in classList" :key="index" :value="classObj.id"
                     :label="superAdmin? `${classObj.schoolName}/${classObj.className}`:`${classObj.className}`"></el-option>
        </el-select>-->
        <el-checkbox :indeterminate="isIndeterminate" v-model="checkAll" @change="handleCheckAllChange">全选</el-checkbox>
        <el-checkbox-group v-model="dataForm.classIdList"  @change="handleCheckedCitiesChange">
          <el-checkbox v-for="classObj in classList" :key="classObj.id" :value="classObj.id" :label="classObj.id">{{classObj.className}}</el-checkbox>
        </el-checkbox-group>
      </el-form-item>
      <el-form-item label="学校" prop="schoolId" v-if="schoolVisible">
        <el-select v-model="dataForm.schoolId" placeholder="请选择学校" clearable>
          <el-option v-for="school in schoolList" :label="school.schoolName" :value="school.id"
                     :key="school.id"></el-option>
        </el-select>
      </el-form-item>
    </el-form>
    <template slot="footer">
      <el-button @click="visible = false">{{ $t('cancel') }}</el-button>
      <el-button type="primary" @click="batchExport()">{{ $t('confirm') }}</el-button>
    </template>
  </el-dialog>
</template>

<script>
import qs from 'qs'
import Cookies from 'js-cookie'
import { Loading } from 'element-ui'
export default {
  data () {
    return {
      visible: false,
      checkAll: false,
      isIndeterminate: true,
      classList: [],
      idList: [],
      //  classIdList: [1375019768665305090, 1375019768677888002],
      schoolVisible: false,
      schoolList: [],
      superAdmin: 0,
      dataForm: {
        classId: '',
        className: '',
        classIdList: [],
        schoolId: ''
      }
    }
  },
  computed: {
    dataRule () {
      return {
        classId: [
          { required: true, message: this.$t('validate.required'), trigger: 'blur' }
        ],
        schoolId: [
          { required: true, message: this.$t('validate.required'), trigger: 'blur' }
        ]
      }
    }
  },
  methods: {
    init () {
      this.visible = true
      this.superAdmin = this.$store.state.user.superAdmin
      this.$nextTick(() => {
        this.$refs.dataForm.resetFields()
        this.resetValue()
        Promise.all([
          this.getClassList()
        ]).then(() => {
          if (this.dataForm.id) {
            this.getInfo()
          }
        })
      })
    },
    handleCheckAllChange (val) {
      this.dataForm.classIdList = val ? this.idList : []
      this.isIndeterminate = false
    },
    handleCheckedCitiesChange (value) {
      const checkedCount = value.length
      this.checkAll = checkedCount === this.idList.length
      this.isIndeterminate = checkedCount > 0 && checkedCount < this.idList.length
    },
    getClassList () {
      this.$http.get('/classmanage/classmanage/getSchoolClassList').then(({ data: res }) => {
        if (res.code !== 0) {
          return this.$message.error(res.msg)
        }
        this.classList = res.data
        for (let i = 0; this.classList.length > 0; i++) {
          this.idList.push(this.classList[i].id)
        }
      }).catch((err) => {
        console.log(err)
      })
    },
    // 获取信息
    getInfo () {
      this.$http.get('/student/student/' + this.dataForm.id).then(({ data: res }) => {
        if (res.code !== 0) {
          return this.$message.error(res.msg)
        }
        this.dataForm = {
          ...this.dataForm,
          ...res.data
        }
      }).catch(() => {
      })
    },
    resetValue () {
      this.dataForm.schoolId = ''
      this.schoolVisible = false
    },
    // 获取学校的集合
    getSchoolList () {
      this.$http.get('/school/school/getSchoolList').then(({ data: res }) => {
        if (res.code !== 0) {
          return this.$message.error(res.msg)
        }
        this.schoolList = res.data
      }).catch((err) => {
        console.log(err)
      })
    },
    exportStudentStatusInfoList () {
      if (!this.dataForm.classId) {
        return this.$message.error('请选择班级')
      }
      this.dataForm.className = this.classList.filter((e) => { return e.id === this.dataForm.classId })[0].className
      const params = qs.stringify({
        token: Cookies.get('token'),
        classIdList: this.classIdList,
        className: this.dataForm.className
      })
      window.open(`${window.SITE_CONFIG.apiURL}/student/studentStatusInfo/exportStudentStatusInfoList?${params}`)
    },
    batchExport () {
      const loadingInstance = Loading.service(this.loadOptions)
      // 数据量巨大一个小时
      this.$http.timeout = 1000 * 60 * 60 * 60
      this.$http
        .post('student/studentStatusInfo/exportStudentStatusInfoList', this.dataForm)
        .then(({ data: res }) => {
          loadingInstance.close()

          if (res.code !== 0) {
            return this.$message.error(res.msg)
          }
          const params = qs.stringify({
            filePath: res.data,
            token: Cookies.get('token')
          })
          window.open(
                        `${window.SITE_CONFIG.apiURL}/student/studentStatusInfo/getBatchExportFile?${params}`
          )
          this.$message({
            message: this.$t('prompt.success'),
            type: 'success',
            duration: 500,
            onClose: () => {
              this.visible = false
              this.$emit('refreshDataList')
            }
          })
        })
        .catch((e) => {
          loadingInstance.close()
          return this.$message.error('批量导出失败')
        })
    }
  }
}
</script>
